/** Pure formatting helpers. */

/**
 * Compact count formatting: 1234 -> "1.23K", 1_500_000 -> "1.5M", capped at 100M+.
 * @param {number} n
 */
export function formatCount(n) {
  if (n >= 1e8) return '100M+';
  if (n >= 1e6) return `${(n / 1e6).toFixed(2).replace(/\.?0+$/, '')}M`;
  if (n >= 1e3) return `${(n / 1e3).toFixed(2).replace(/\.?0+$/, '')}K`;
  return String(n);
}

/** Normalise a path so it always begins with a single leading slash. */
export function normalisePath(p) {
  if (!p) return '';
  return p.startsWith('/') ? p : `/${p}`;
}

/** Strip a single trailing slash. */
export function stripTrailingSlash(url) {
  return (url || '').replace(/\/$/, '');
}
